import { Time } from "@angular/common";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseEntity, DateTimeModel, NgbDateTimeStruct } from "yt-ng-framework";

export class EOtpremnica extends BaseEntity{

    constructor(){
        super();
    }

    PodVrstaDokumentaStavkaID: number = null;
    Broj: string = null;
    Datum: Date = null;
    TipOtpremniceID:number=null;
    Povrat:boolean = false;
    //-
    Napomena: string = "";
    //-
    MasterDokumID: number = null;
    BrojOtpremnice:string=null;
    DatumOtpremnice:Date=null;
    TipOtpremnice:string=null;
    BrojNarudzbenice:string=null;
    DatumNarudzbenice:Date=null;
    BrojIsporuke:string=null;
    UkupanBrojPaketa:number=0;
    TezinaIsporuke: number=null;
    JedinicaMereZaTezinu: number=null;
    ZapreminaIsporuke: number = null;
    JedinicaMereZaZapreminu: number = null;
    NapomenaDostave: string = null;

    // Podaci o pošiljaocu
    PosiljaocID:number=null;
    ObjekatPosiljaocaID:number=null;
    //-
    PibPosiljaoca:string=null;
    NazivPosiljaoca:string=null;
    NazivPosiljaoca2:string=null;
    UlicaPosiljaoca:string=null;
    DodatnoUlicaPosiljaoca:string=null;
    GradPosiljaoca:string=null;
    PostanskiBrojPosiljaoca:string=null;
    PodentitetPosiljaoca:string=null;
    BrojUUliciPosiljaoca:string=null;
    MaticniBrojPosiljaoca:string=null;
    GlnPosiljaoca:string=null;
    EmailPosiljaoca:string=null;
    ImeIPrezimePosiljaoca:string=null;
    TelefonPosiljaoca:string=null;
    JBKJSPosiljaoca:string=null;

    // Podaci o otpremi
    NacinOtpremeID: number = null;
    //-
    NacinOtpreme:string=null;
    UlicaOtpreme:string=null;
    DodatnaUlicaOtpreme:string=null;
    GradOtpreme:string=null;
    PostanskiBrojOtpreme:string=null;
    PodentitetOtpreme:string=null;
    BrojUUliciOtpreme:string=null;
    PlaniraniPocetakOtpreme:Date=null;
    PlaniraniZavrsetakOtpreme:Date=null;
    KurirIme:string=null;
    KurirPrezime:string=null;
    KurirLK:string=null;

    // Podaci o primaocu
    PrimaocID:number=null;
    ObjekatPrimaocaID:number=null;
    //-
    PibPrimaoca:string=null;
    NazivPrimaoca:string=null;
    NazivPrimaoca2:string=null;
    UlicaPrimaoca:string=null;
    DodatnoUlicaPrimaoca:string=null;
    GradPrimaoca:string=null;
    PostanskiBrojPrimaoca:string=null;
    PodentitetPrimaoca:string=null;
    BrojUUliciPrimaoca:string=null;
    MaticniBrojPrimaoca:string=null;
    GlnPrimaoca:string=null;
    EmailPrimaoca:string=null;
    ImeIPrezimePrimaoca:string=null;
    TelefonPrimaoca:string=null;
    JBKJSPrimaoca:string=null;

    // Podaci o dostavi
    UlicaDostave:string=null;
    DodatnaUlicaDostave:string=null;
    GradDostave:string=null;
    PostanskiBrojDostave:string=null;
    PodentitetDostave:string=null;
    BrojUUliciDostave:string=null;
    StvarnoVremeDostave:Date=null;
    EoID: string = null;
    StatusID: number = null;
    StatusColor: string = null;
    //
    ProvajderID: number=null;
    OsvezivogStatusa: boolean= null;
    StatusGenericName: string;  
    BrojUlazneOtpremnice: string = null; 
    StatusTooltip: string = null;
    BrojIzlaznePrijemnice: string= null;


    Deserialize(input: any){
        super.Deserialize(input);
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.TipOtpremniceID=input.TipOtpremniceID;
        this.Povrat=input.Povrat;
        //-
        this.Napomena = input.Napomena != null ? input.Napomena.trim() : input.Napomena;
        //-
        this.MasterDokumID = input.MasterDokumID;
        this.BrojOtpremnice=input.BrojOtpremnice;
        this.EoID = input.EoID;
        this.StatusID = input.StatusID;
        this.StatusColor = input.StatusColor;
        this.OsvezivogStatusa=input.OsvezivogStatusa;
//         // Konverzija ako server vrati string
//   if (input.DatumOtpremnice) {
//     this.DatumOtpremnice = new Date(input.DatumOtpremnice);
//   }

//   // Ako se koristi ng-bootstrap picker koji vraća {year, month, day}
//   else if (input.DatumOtpremnice && input.DatumOtpremnice.year) {
//     const d = input.DatumOtpremnice;
//     this.DatumOtpremnice = new Date(d.year, d.month - 1, d.day);
//   }

       this.DatumOtpremnice =input.DatumOtpremnice; 

        this.TipOtpremnice=input.TipOtpremnice;
        this.BrojNarudzbenice=input.BrojNarudzbenice;
        this.DatumNarudzbenice=input.DatumNarudzbenice;
        this.BrojIsporuke=input.BrojIsporuke;
        this.UkupanBrojPaketa=input.UkupanBrojPaketa;
        this.TezinaIsporuke=input.TezinaIsporuke;
        this.JedinicaMereZaTezinu=input.JedinicaMereZaTezinu;
        this.ZapreminaIsporuke=input.ZapreminaIsporuke;
        this.JedinicaMereZaZapreminu=input.JedinicaMereZaZapreminu;

        // Podaci o pošiljaocu
        this.PosiljaocID=input.PosiljaocID;
        this.ObjekatPosiljaocaID=input.ObjekatPosiljaocaID;
        //-
        this.PibPosiljaoca=input.PibPosiljaoca;
        this.NazivPosiljaoca=input.NazivPosiljaoca;
        this.NazivPosiljaoca2=input.NazivPosiljaoca2;
        this.UlicaPosiljaoca=input.UlicaPosiljaoca;
        this.DodatnoUlicaPosiljaoca=input.DodatnoUlicaPosiljaoca;
        this.GradPosiljaoca=input.GradPosiljaoca;
        this.PostanskiBrojPosiljaoca=input.PostanskiBrojPosiljaoca;
        this.PodentitetPosiljaoca=input.PodentitetPosiljaoca;
        this.BrojUUliciPosiljaoca=input.BrojUUliciPosiljaoca;
        this.MaticniBrojPosiljaoca=input.MaticniBrojPosiljaoca;
        this.GlnPosiljaoca=input.GlnPosiljaoca;
        this.EmailPosiljaoca=input.EmailPosiljaoca;
        this.ImeIPrezimePosiljaoca=input.ImeIPrezimePosiljaoca;
        this.TelefonPosiljaoca=input.TelefonPosiljaoca;
        this.JBKJSPosiljaoca=input.JBKJSPosiljaoca;
        
        // Podaci o otpremi
        this.NacinOtpremeID=input.NacinOtpremeID;
        //-
        this.NacinOtpreme=input.NacinOtpreme;
        this.UlicaOtpreme=input.UlicaOtpreme;
        this.DodatnaUlicaOtpreme=input.DodatnaUlicaOtpreme;
        this.GradOtpreme=input.GradOtpreme;
        this.PostanskiBrojOtpreme=input.PostanskiBrojOtpreme;
        this.PodentitetOtpreme=input.PodentitetOtpreme;
        this.BrojUUliciOtpreme=input.BrojUUliciOtpreme;
        this.KurirIme=input.KurirIme;
        this.KurirPrezime=input.KurirPrezime;
        this.KurirLK=input.KurirLK;

        // Podaci o primaocu
        this.PrimaocID=input.PrimaocID;
        this.ObjekatPrimaocaID=input.ObjekatPrimaocaID;
        //-
        this.PibPrimaoca=input.PibPrimaoca;
        this.NazivPrimaoca=input.NazivPrimaoca;
        this.NazivPrimaoca2=input.NazivPosiljaoca2;
        this.UlicaPrimaoca=input.UlicaPrimaoca;
        this.DodatnoUlicaPrimaoca=input.DodatnoUlicaPrimaoca;
        this.GradPrimaoca=input.GradPrimaoca;
        this.PostanskiBrojPrimaoca=input.PostanskiBrojPrimaoca;
        this.PodentitetPrimaoca=input.PodentitetPrimaoca;
        this.BrojUUliciPrimaoca=input.BrojUUliciPrimaoca;
        this.MaticniBrojPrimaoca=input.MaticniBrojPrimaoca;
        this.GlnPrimaoca=input.GlnPrimaoca;
        this.EmailPrimaoca=input.EmailPrimaoca;
        this.ImeIPrezimePrimaoca=input.ImeIPrezimePrimaoca;
        this.TelefonPrimaoca=input.TelefonPrimaoca;
        this.JBKJSPrimaoca=input.JBKJSPrimaoca;
        // Podaci o dostavi
        this.UlicaDostave=input.UlicaDostave;
        this.DodatnaUlicaDostave=input.DodatnaUlicaDostave;
        this.GradDostave=input.GradDostave;
        this.PostanskiBrojDostave=input.PostanskiBrojDostave;
        this.PodentitetDostave=input.PodentitetDostave;
        this.BrojUUliciDostave=input.BrojUUliciDostave;
        this.NapomenaDostave = input.NapomenaDostave;
        // this.PlaniraniPocetakOtpreme=input.PlaniranoVremeDostave;
        // this.PlaniraniZavrsetakOtpreme=input.VremeDostave;
        // this.StvarnoVremeDostave=input.StvarnoVremeDostave;
        this.PlaniraniPocetakOtpreme=input.PlaniraniPocetakOtpreme;
        this.PlaniraniZavrsetakOtpreme=input.PlaniraniZavrsetakOtpreme;
        this.StvarnoVremeDostave=input.StvarnoVremeDostave;
        this.ProvajderID=input.ProvajderID;
        this.StatusGenericName = input.StatusGenericName;
        this.BrojUlazneOtpremnice = input.BrojUlazneOtpremnice;

        this.StatusTooltip = input.StatusTooltip;

        this.BrojIzlaznePrijemnice = input.BrojIzlaznePrijemnice;
        
        return this;
    }

Serialize(input: EOtpremnica): any {
    const output: any = Object.assign({}, input);

    const convertDate = (val: any) => {
        if (!val) return null;
        if (val instanceof Date) return val.toISOString();
        if (val.year) {
            const d = val as any;
            return new Date(d.year, d.month - 1, d.day, d.hour || 0, d.minute || 0).toISOString();
        }
        return val;
    };

    // --- Konverzija svih datuma ---
    // output.DatumOtpremnice = convertDate(input.DatumOtpremnice);
    output.DatumNarudzbenice = convertDate(input.DatumNarudzbenice);
    output.StvarnoVremeDostave = convertDate(input.StvarnoVremeDostave);
    output.PlaniraniPocetakOtpreme = convertDate(input.PlaniraniPocetakOtpreme);
    output.PlaniraniZavrsetakOtpreme = convertDate(input.PlaniraniZavrsetakOtpreme);

    return output;
}


    GetInstance(){
        return this;
    }
}

